import { Point } from '../types/point';
import { Shape } from '../types/shape';

export abstract class SvgItem<TData> {

  protected data: TData;

  constructor(data: TData) {
    this.data = data;
  }

  public getData() {
    return this.data;
  }

  public setData(data: TData) {
    this.data = data;
  }

  public abstract getShape(): Shape;

  public abstract getCoordinate(): Point;


  public getWidth(): number {
    return 0;
  }

  public getheight(): number {
    return 0;
  }

  public getRadius(): number {
    return 0;
  }

  public getFill(): string {
    return 'lightgray';
  }

  public getImageUrl(): string {
    return null;
  }

  public getLabelOffsetX(): number {
    return 0;
  }

  public getLabelOffsetY(): number {
    return 0;
  }

  public getFontColor(): string {
    return 'black';
  }

  public getFontSize(): number {
    return 14;
  }

  public getText(): string {
    return '';
  }

  public getFontWeight(): number {
    return 0;
  }

  public getBorderColor(): string {
    return '';
  }

  public getBorderSize(): number {
    return 0;
  }

  public getRotation(): number {
    return 0;
  }

  public getIsBlink(): boolean {
    return false;
  }

}
